import { useRows } from "../lib/db";

/** Owner and POS Settings: QR or app only, a Print key on Paid, or printed with every sale. */
export type ReceiptMode = "digital" | "ask" | "print";

/** The paired store's real display/tax/currency config, read from the local PowerSync copy of core.stores. */
export function useStoreConfig(storeId: string) {
  const result = useRows("stores", "SELECT * FROM stores WHERE id = $1", [storeId]);
  const store = result?.rows[0] ?? null;
  const printers = useRows("printers", "SELECT * FROM printers WHERE store_id = $1 AND role = 'receipt' AND deleted_at IS NULL", [storeId]);
  const receiptMode = ((store?.settings as { receipt_mode?: ReceiptMode } | undefined)?.receipt_mode ?? "digital") as ReceiptMode;
  return {
    store,
    name: store?.name ?? "Store",
    address: store?.address ?? null,
    currencyCode: store?.currency_code ?? "MMK",
    currencyPrecision: store?.currency_precision ?? 0,
    taxRate: Number(store?.tax_rate ?? 0.05),
    taxLabel: store?.tax_label ?? "Tax",
    employeeDiscountEnabled: store?.employee_discount_enabled ?? false,
    employeeDiscountPercent: store?.employee_discount_percent ?? 10,
    receiptMode,
    /** What the till can do: with no receipt printer, Paid and Bills stay digital whatever is set. */
    paperMode: printers?.rows.length ? receiptMode : ("digital" as ReceiptMode),
  };
}
